var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#E1E1E3",
    strokeWidth: 2,
    d: "M7.692 1c-2.288 0-3.204.177-4.15.683a4.452 4.452 0 0 0-1.859 1.858C1.177 4.488 1 5.404 1 7.691v30.617c0 2.288.177 3.204.683 4.15a4.452 4.452 0 0 0 1.858 1.859c.947.506 1.863.683 4.15.683h20.617c2.288 0 3.204-.177 4.15-.683a4.452 4.452 0 0 0 1.859-1.858c.506-.947.683-1.863.683-4.15V14.501c0-1.387-.04-1.902-.168-2.456a4.224 4.224 0 0 0-.552-1.332c-.302-.482-.638-.874-1.62-1.854l-5.538-5.528c-.98-.979-1.373-1.314-1.854-1.615a4.224 4.224 0 0 0-1.33-.55C23.387 1.04 22.872 1 21.487 1H7.692z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A6CFE2",
    d: "M18 22.546c4.666 0 3.838 11.138 0 13.518-3.84-2.398-4.664-13.518 0-13.518z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89C1DD",
    d: "M17.982 22.546c4.042 2.333-2.244 11.565-6.759 11.706-2.126-3.996 2.721-14.038 6.76-11.706z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87B0E9",
    d: "M17.97 22.545c2.334 4.042-7.726 8.894-11.707 6.76.157-4.525 9.376-10.798 11.707-6.76z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9CDD",
    d: "M17.966 22.545c0 4.667-11.138 3.84-13.518 0 2.398-3.839 13.518-4.663 13.518 0z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF2153",
    d: "M17.974 22.554C15.641 26.596 6.41 20.31 6.268 15.795c3.996-2.125 14.038 2.721 11.706 6.76z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8B8B",
    d: "M17.975 22.542c-4.042 2.334-8.894-7.726-6.76-11.707 4.525.157 10.798 9.376 6.76 11.707z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB9B2A",
    d: "M17.975 22.538c-4.667 0-3.84-11.137 0-13.518 3.84 2.398 4.663 13.518 0 13.518z",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FACA0C",
    d: "M18.018 22.546c-4.042-2.333 2.244-11.565 6.759-11.706 2.126 3.996-2.721 14.038-6.76 11.706z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8EC64",
    d: "M18.03 22.547c-2.334-4.042 7.726-8.894 11.707-6.76-.157 4.525-9.376 10.798-11.707 6.76z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32B67A",
    d: "M18.034 22.547c0-4.667 11.138-3.84 13.518 0-2.398 3.84-13.518 4.663-13.518 0z",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00EACF",
    d: "M18.026 22.538c2.333-4.042 11.565 2.244 11.706 6.759-3.996 2.126-14.038-2.72-11.706-6.76z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BBCD6",
    d: "M18.025 22.55c4.042-2.334 8.894 7.726 6.76 11.707-4.525-.157-10.798-9.376-6.76-11.707z",
    style: {
      mixBlendMode: "multiply"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImage);
export default __webpack_public_path__ + "static/media/file-image.128d0098106e8e4e7ef16029472ed5f7.svg";
export { ForwardRef as ReactComponent };